import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <path
    {...props}
    d="M54.38,41.36c0,.33-26.88,13-27.65,12.65L5.28,35.48s8.25,1.13,10.56.67c0-.06,9.46-23.93,9.46-23.93h0l1.56-2.17,1.21,0,5.73.24L48.07,24C48.07,24.14,54.38,41.17,54.38,41.36Z"
  />
);

const SortingHatAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_5}
    renderShadow={renderShadow}
  >
    <>
      <path
        d="M38.41,33.63a96.43,96.43,0,0,1-13.76.1l-1.55-.1c-1.92.35-3.86.62-5.8.81h0l-.08,0a.33.33,0,0,1-.19-.16A.36.36,0,0,1,17,34l.09-.28-2.49-.39.39-.37-.39,0H15l1-.93a1.75,1.75,0,0,0,.57-.75,1.06,1.06,0,0,0-.14-.9,2,2,0,0,1-.25-.35.88.88,0,0,1,.07-.67A1.49,1.49,0,0,1,16.4,29a6,6,0,0,1-.26-.75A5.54,5.54,0,0,1,17.05,25a9.57,9.57,0,0,0,.76-1.75,6.79,6.79,0,0,0,.2-1.74,11.93,11.93,0,0,1-.27-2.06,4.17,4.17,0,0,1,.86-1.92,4.09,4.09,0,0,0,.79-1.64,9.09,9.09,0,0,1,.31-2.08l0,0a2.91,2.91,0,0,1,1-1,6.68,6.68,0,0,0,1.58-3.23,4.17,4.17,0,0,1,.58-1.6l0,0c.48-.35,3.89-2.95,4.52-2.64a16.24,16.24,0,0,0,2.35.41c1.5.21,3.41,4,4.06,4.71.19.2.34,1.15-.32.88-1.45-.69-3.57-1.44-4.25-.57s.7,3.27-.16,3.92a1.65,1.65,0,0,1-.25.15c-.17.09-.3.15-.37.35a3.54,3.54,0,0,0,.07,1.52A21.14,21.14,0,0,1,30,21.94a10.22,10.22,0,0,0,.87,3.64A10,10,0,0,0,31.71,27a11.09,11.09,0,0,1,.73,1.21,3.18,3.18,0,0,1,.23.58,3.65,3.65,0,0,0,.29.66.75.75,0,0,0,.14.17h0a.19.19,0,0,1,.1,0,.26.26,0,0,1,.14.29c5-.55,9.77-.59,10,.65S42.64,33.1,38.41,33.63Z"
        style={{ fill: '#7c695e' }}
      />
      <path
        d="M29.31,20.49s0,0,0,.05a.24.24,0,0,0,0-.08Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M32.28,29.64c-.72,0-2.26-.38-3-.46a46.54,46.54,0,0,0-5.4.4c-1.85.23-4.88,2.71-6.28,2.79-.3,0,4.76-3.52,4.76-3.52,1.3-.88,4.66-.57,6.18-1C30.28,27.5,32.83,29.64,32.28,29.64Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M27.58,14.53a7.25,7.25,0,0,1-1.8-.68,4.34,4.34,0,0,0-2.14-.27c-.1,0-.22,0-.25.13s.08.25.2.32a9.83,9.83,0,0,0,3.65,1.58"
        style={{ fill: '#7c695e' }}
      />
      <path
        d="M26.91,6.68a2,2,0,0,0,.2,2c.19.27.45.48.65.74a2.35,2.35,0,0,1,.42,2"
        style={{ fill: '#7c695e' }}
      />
      <path d="M28.37,6.62a3.29,3.29,0,0,0-.57,2" style={{ fill: '#7c695e' }} />
      <path
        d="M23,8.15A1.89,1.89,0,0,1,24.68,9a13.29,13.29,0,0,1,1,1.76,2.51,2.51,0,0,0,1.46,1.29"
        style={{ fill: '#7c695e' }}
      />
      <path
        d="M30.83,33.89A81.84,81.84,0,0,1,20.36,36c-6.78.91-15.83.95-15.08-.55,1.28-2.58,5.68-2.69,9.47-2.61h0c.81.1,4.25.51,9.88.84C26.06,33.8,28.38,33.88,30.83,33.89Z"
        style={{ fill: '#594c45' }}
      />
      <path
        d="M30.36,22.69a5.81,5.81,0,0,0,.12,1.84,15.51,15.51,0,0,0-3.62-1.16c-1.07.06-2.18,1.39-3.38,1.51-1,.11-2-1.73-2.5-2.68a4.63,4.63,0,0,0-1.05-1,26.51,26.51,0,0,1,2.17-2.56c.76-.28,5.95,1.6,6.38,1.5a3.14,3.14,0,0,1,2.08.88C30.72,21.22,30.4,22.35,30.36,22.69Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M28.88,30.22c-.1,0-.25.14-.34.18l-.37.16a5.48,5.48,0,0,1-.79.23,7.49,7.49,0,0,1-1.68.29c-.4,0-.47-.29-.23-.58s.91-.19,1.31-.18C27.48,30.32,28.18,30.29,28.88,30.22Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M28.76,17.07c2,3.47,1.57,2.75,2.26,3.57a.42.42,0,0,1,0,.57,8.55,8.55,0,0,1-4.16,1.31c-1.39-.15-3.29-2.28-4-2.41s-2.9,1.45-2.9,1.45l-1.1-2.4Z"
        style={{ fill: '#7c695e' }}
      />
      <path
        d="M30.79,8.8a7.72,7.72,0,0,1,2.67,1.85c0,.09-.33.08-.42,0a3.83,3.83,0,0,0-2.26-.92c-1.17,0-1.38.25-1.74-.22-.18-.22-.24-.13.36-.43A2.62,2.62,0,0,1,30.79,8.8Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M28.53,10.27a1.73,1.73,0,0,1-1-.16c-.53-.35-.6-1.19-.65-1.75,0-.07-.05-.19,0-.25s.07-.06.1,0,0,.2.07.26a2.56,2.56,0,0,0,.11.24,6,6,0,0,0,.56.86,5,5,0,0,0,.37.43l.2.2S28.48,10.27,28.53,10.27Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M22.51,9.29l.38-1.21a3.34,3.34,0,0,1,.44.54c.24.37.39.8.61,1.18a3.38,3.38,0,0,0,1.66,1.44,4.2,4.2,0,0,1-1.36-.35,3,3,0,0,1-.54-.39,10.12,10.12,0,0,1-1.06-1C22.59,9.43,22.56,9.36,22.51,9.29Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M25.09,15.47a6.34,6.34,0,0,1-4.47.58,3.5,3.5,0,0,0,2,.95,7.72,7.72,0,0,0,2.25,0c.61-.09,1.22-.2,1.82-.34a2.46,2.46,0,0,0,1-.4.9.9,0,0,0,.32-1l-2.43.49c.43-.24.86-.47,1.28-.73.21-.12.42-.25.62-.39s.33-.19.38-.36,0-.56-.29-.41-.74.58-1.13.84A11.15,11.15,0,0,1,25.09,15.47Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M27,21.58c0,.06,0,.13.1.15h.13a4.23,4.23,0,0,0,2-1,1.34,1.34,0,0,0,.34-.33.18.18,0,0,0,.05-.17.2.2,0,0,0-.19-.1,1.13,1.13,0,0,0-.79.3,3.14,3.14,0,0,1-.7.49,1.13,1.13,0,0,1-.63.06.18.18,0,0,0-.21,0,.84.84,0,0,0-.08.27A1.15,1.15,0,0,0,27,21.58Z"
        style={{ fill: '#473c35' }}
      />
      <path
        d="M31.39,31.9a9,9,0,0,0-1.61.82.89.89,0,0,0,.53-.07,39.09,39.09,0,0,0,4.88-2.32c.44-.21-1.26,0-1.49,0a3.72,3.72,0,0,0-1.28.88A5.4,5.4,0,0,1,31.39,31.9Z"
        style={{ fill: '#473c35' }}
      />
    </>
  </AvatarArtwork>
);

export default SortingHatAvatarArtwork;
